import { RouteConfig } from 'vue-router'

const Index = () => import(/* webpackChunkName: "board" */ '@board/Index.vue')
const BoardMaster = () => import(/* webpackChunkName: "board" */ '@board/views/Master.vue')
const BoardNoHeaderMaster = () => import(/* webpackChunkName: "board" */ '@board/views/NoHeaderMaster.vue')
const ModalMaster = () => import(/* webpackChunkName: "board" */ '@board/views/ModalMaster.vue')

const BoardMain = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardMain.vue')

const TotalBoardMain = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/TotalBoardMain.vue')

const BoardList = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardList.vue')

const BoardAdminList = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardAdminList.vue')

const BoardAlbum = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardAlbum.vue')

const BoardSummary = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardSummary.vue')

const BoardWrite = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardWrite.vue')

const BoardRead = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardRead.vue')

const BoardViewLog = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardViewLog.vue')

const BoardWritePage = () =>
    import(/* webpackChunkName: "board" */ '@board/components/board/BoardWritePage.vue')

const PopupMaster = () => import(/* webpackChunkName: "board" */ '@board/views/PopupMaster.vue')

const popupRoutes = [
    {
        path: 'boardpopup',
        component: PopupMaster,
        children: [
            {
                path: 'writepopup',
                component: BoardWrite,
            },
            {
                path: 'readpopup',
                component: BoardRead,
            },
            {
                path: 'viewlogpopup',
                component: BoardViewLog,
            }
        ]
    }  
]

const standaloneRoutes: RouteConfig[] = [
    {
        path: 'board',
        component: Index,
        children: [
            {
                path: '',
                component: BoardMaster,                
                children: [
                    {

                        path: '',
                        component: BoardMain,
                        name: 'boardmodule-main',
                        children: [
                            {
                                path: 'modal',
                                component: ModalMaster,
                                children: [
                                    {
                                        path: 'write',
                                        component: BoardWrite,
                                    },
                                    {
                                        path: 'read',
                                        component: BoardRead,
                                    },
                                ],
                            }                
                        ],
                    },      
                    {
                        path: 'total',
                        component: TotalBoardMain,
                        children: [
                            {
                                path: 'modal',
                                component: ModalMaster,
                                children: [
                                    {
                                        path: 'write',
                                        component: BoardWrite,
                                    },
                                    {
                                        path: 'read',
                                        component: BoardRead,
                                    },
                                ],
                            },
                        ]
                    }                             
                ]                
            }            
        ],
    }
]

const moduleRoutes: RouteConfig[] = [
    {
        path: 'board',
        component: BoardMain,
        name: 'boardmodule-main',
        children: [
            {
                path: 'modal',
                component: ModalMaster,
                children: [
                    {
                        path: 'write',
                        component: BoardWrite,
                    },
                    {
                        path: 'read',
                        component: BoardRead,
                    },
                ],
            }                
        ],
    }        
]

const routes: RouteConfig[] = [
    ...standaloneRoutes,
    ...popupRoutes
]
export default {
    routes,
    moduleRoutes,
    popupRoutes
}
